<template>
  <display-modal v-if="showImport" @ridfeedback="showImport = false">
    <grid-import @import-grid="feedIntoGrid"></grid-import>
  </display-modal>
  <div
    class="w-full mx-auto sm:w-[98%] py-4 grid grid-cols-1 sm:grid-cols-2 gap-4"
  >
    <div v-for="n in 4" :key="`${n}-${boxRecordId || wellNo}`">
      <div
        v-show="
          n < 2 ||
          this.puckData.puckType != 'Cartridge' ||
          (this.puckData.puckType == 'Cartridge' && this.wellNo < 3)
        "
        class="text-sm p-4 rounded-lg"
        style="background-color: rgb(217, 217, 217)"
      >
        <div class="flex items-stretch">
          <div class="flex-shrink basis-[84%] sm:basis-[88%]">
            <label class="mb-1 block text-xs font-semibold uppercase tracking-[0.12em] text-slate-600">
              Grid Name
            </label>
            <div class="flex">
              <input
                @input="
                  saveData(
                    $event,
                    boxRecordId,
                    'boxes',
                    'gridProperty',
                    false,
                    {
                      gridProperty: {
                        [gridNameFromNumber(n)]: {
                          name: gridName[n - 1],
                        },
                        gridupdate: [gridNameFromNumber(n), 'name'],
                        puckId: puckId,
                        wellNo: wellNo,
                        rackIndex: this.dataChainForMove.rack,
                        puckIndex: this.puckIndex,
                      },
                    }
                  )
                "
                @blur="
                  saveData(
                    $event,
                    boxRecordId,
                    'boxes',
                    'gridProperty',
                    true,
                    {
                      gridProperty: {
                        [this.gridNameFromNumber(n)]: {
                          name: gridName[n - 1],
                        },
                        gridupdate: [gridNameFromNumber(n), 'name'],
                        puckId: puckId,
                        wellNo: wellNo,
                        rackIndex: this.dataChainForMove.rack,
                        puckIndex: this.puckIndex,
                      },
                    }
                  )
                "
                :ref="'gridName' + n"
                v-model="gridName[n - 1]"
                class="flex-1"
                type="text"
                placeholder="Type here..."
              />

              <div
                :class="{ invisible: boxType == 'opencup' }"
                class="aspect-square mx-4 flex flex-shrink-0 flex-grow max-w-[2rem] max-h-[2rem] items-center justify-center bg-sky-900 rounded-full text-white text-base font-bold text-center"
              >
                {{ boxOrderArray[n - 1] }}
              </div>
            </div>
          </div>

          <div
            class="flex-grow flex-shrink basis-[16%] sm:basis-[12%]"
            :ref="'bigCircle-' + n"
            v-show="
              this.puckData.puckType != 'Cartridge' ||
              (this.puckData.puckType == 'Cartridge' && this.wellNo < 3)
            "
          ></div>
        </div>
        <div>
          <label class="mb-1 block text-xs font-semibold uppercase tracking-[0.12em] text-slate-600">
            Description
          </label>
          <div>
            <textarea
              placeholder="Type here..."
              name=""
              id=""
              class="w-full"
              rows="5"
              @input="
                saveData($event, boxRecordId, 'boxes', 'gridProperty', false, {
                  gridProperty: {
                    [gridNameFromNumber(n)]: {
                      // gridType: this.gridType[number - 1],
                      // name: gridName[n - 1],

                      description: this.gridDescription[n - 1],
                    },
                    gridupdate: [gridNameFromNumber(n), 'description'],
                    puckId: puckId,
                    wellNo: wellNo,
                    rackIndex: dataChainForMove.rack,
                    puckIndex: puckIndex,
                  },
                })
              "
              @blur="
                saveData($event, boxRecordId, 'boxes', 'gridProperty', true, {
                  gridProperty: {
                    [this.gridNameFromNumber(n)]: {
                      // gridType: this.gridType[n - 1],
                      // name: gridName[n - 1],
                      // trueDateCreated: showDatePicker[n - 1],
                      description: this.gridDescription[n - 1],
                    },
                    gridupdate: [gridNameFromNumber(n), 'description'],
                    puckId: puckId,
                    wellNo: wellNo,
                    rackIndex: this.dataChainForMove.rack,
                    puckIndex: this.puckIndex,
                  },
                })
              "
              v-model="gridDescription[n - 1]"
            ></textarea>
          </div>
          <div class="mb-3">
            <label class="mb-1 block text-xs font-semibold uppercase tracking-[0.12em] text-slate-600">
              Grid Type
            </label>
            <select
              v-model="gridCatalogType[n - 1]"
              class="w-auto max-w-full blueborder"
              @change="
                saveData($event, boxRecordId, 'boxes', 'gridProperty', true, {
                  gridProperty: {
                    [gridNameFromNumber(n)]: {
                      gridCatalogType: gridCatalogType[n - 1] || null,
                    },
                    gridupdate: [gridNameFromNumber(n), 'gridCatalogType'],
                    puckId: puckId,
                    wellNo: wellNo,
                    rackIndex: dataChainForMove.rack,
                    puckIndex: puckIndex,
                  },
                })
              "
            >
              <option value="">Select grid type...</option>
              <template v-if="gridCatalogType[n - 1] && !isKnownCatalogType(gridCatalogType[n - 1])">
                <option :value="gridCatalogType[n - 1]">{{ gridCatalogType[n - 1] }} (custom)</option>
              </template>
              <optgroup v-for="group in gridCatalogTypeGroups" :key="group.label" :label="group.label">
                <option
                  v-for="option in group.options"
                  :key="`${n}-${option}`"
                  :value="option"
                >
                  {{ option }}
                </option>
              </optgroup>
            </select>
          </div>
          <div class="mb-3">
            <label
              class="tomography-toggle"
              :class="{ 'tomography-toggle--active': forTomography[n - 1] }"
            >
              <input
                type="checkbox"
                :checked="forTomography[n - 1]"
                class="tomography-toggle__input"
                @change="toggleTomography(n, $event)"
              />
              <span class="tomography-toggle__track">
                <span class="tomography-toggle__thumb"></span>
              </span>
              <span class="tomography-toggle__label">Tomography</span>
              <span v-if="forTomography[n - 1]" class="tomography-toggle__badge">CryoET</span>
            </label>
          </div>
          <div
            v-if="getGridAtPosition(n)?.id && forTomography[n - 1]"
            class="mt-2 mb-3 grid grid-cols-2 gap-2 text-xs sm:grid-cols-4"
          >
            <div class="rounded-xl bg-white/80 px-3 py-2">
              <div class="font-bold text-slate-900">{{ getLamellaSummaryAtPosition(n).total }}</div>
              <div class="text-slate-500 uppercase tracking-[0.14em] text-[0.63rem]">Lamellae</div>
            </div>
            <div class="rounded-xl bg-cyan-50 px-3 py-2">
              <div class="font-bold text-cyan-900">{{ getLamellaSummaryAtPosition(n).active }}</div>
              <div class="text-cyan-700 uppercase tracking-[0.14em] text-[0.63rem]">Active</div>
            </div>
            <div class="rounded-xl bg-emerald-50 px-3 py-2">
              <div class="font-bold text-emerald-900">{{ getLamellaSummaryAtPosition(n).completed }}</div>
              <div class="text-emerald-700 uppercase tracking-[0.14em] text-[0.63rem]">Done</div>
            </div>
            <div class="rounded-xl bg-rose-50 px-3 py-2">
              <div class="font-bold text-rose-900">{{ getLamellaSummaryAtPosition(n).alert }}</div>
              <div class="text-rose-700 uppercase tracking-[0.14em] text-[0.63rem]">Alert</div>
            </div>
          </div>
          <div>
            <div class="hidden"></div>

            <!-- ADD BUTTON -->
            <button
              v-if="!gridImage[n - 1]"
              class="bg-gray-200 rounded text-black border-black border px-2 py-1 text-xs mb-3 hover:bg-slate-300 hover:text-slate-900 addimagebutton"
              @click="
                (ev) => {
                  // Find the file input relative to the main container div (more robust)
                  const fileInput = ev.currentTarget
                    .closest('div')
                    .querySelector('input[type=file]');
                  if (fileInput) {
                    fileInput.value = ''; // Clear previous selection
                    fileInput.click();
                  }
                }
              "
            >
              Add an image
            </button>

            <!-- EDIT/VIEW BUTTONS -->
            <div class="flex items-end editgroup" v-else>
              <a
                target="_blank"
                class="mr-2 underline mb-2"
                :href="gridImage[n - 1]"
                >View Image</a
              >
              <button
                class="bg-gray-200 rounded text-black border-black border px-2 py-1 text-xs mb-3 hover:bg-slate-300 hover:text-slate-900"
                @click="
                  (ev) => {
                    // Traverse up to the common parent of the div and the input
                    const commonParent =
                      ev.currentTarget.closest('div').parentElement; // Go up one level from the button's parent div
                    const fileInput =
                      commonParent.querySelector('input[type=file]');

                    if (fileInput) {
                      fileInput.value = ''; // Clear previous selection
                      fileInput.click();
                    } else {
                      console.error('File input not found!'); // Add this for debugging
                    }
                  }
                "
              >
                Edit image
              </button>
            </div>

            <!-- FILE INPUT - Use @change -->
            <input
              @change="(ev) => handleFileChange(ev.currentTarget, n)"
              type="file"
              accept="image/*"
              style="display: none"
            />
            <!-- Loading indicator (keep hidden initially) -->
            <div class="mb-3 text-xs text-black hidden">Uploading image</div>
          </div>

          <div class="flex mb-2" :ref="'gridType' + n">
            <div
              style="
                background-color: rgb(191, 216, 235);
                border-color: rgb(118, 155, 186);
              "
              class="flex rounded p-2 border flex-wrap"
            >
              <div class="flex items-end mr-6">
                <input
                  class="cursor-pointer w-4 h-4"
                  style="margin-bottom: 0"
                  type="checkbox"
                  :checked="!!gridType[n - 1][0]"
                  :id="'screened-' + n"
                  :name="'screentype-' + n"
                  v-model="gridType[n - 1][0]"
                  @change="
                    saveData(
                      $event,
                      boxRecordId,
                      'boxes',
                      'gridProperty',
                      true,
                      {
                        gridProperty: {
                          [this.gridNameFromNumber(n)]: {
                            gridType: this.gridType[n - 1],
                          },
                          gridupdate: [gridNameFromNumber(n), 'gridType'],
                          puckId: puckId,
                          wellNo: wellNo,
                          rackIndex: this.dataChainForMove.rack,
                          puckIndex: this.puckIndex,
                        },
                      }
                    )
                  "
                />
                <label
                  class="pl-1 cursor-pointer leading-none"
                  :name="'screentype-' + n"
                  :for="'screened-' + n"
                  >Screened</label
                >
              </div>
              <div class="flex items-end mr-6">
                <input
                  class="cursor-pointer w-4 h-4"
                  style="margin-bottom: 0"
                  type="checkbox"
                  :checked="!!gridType[n - 1][1]"
                  :name="'screentype-' + n"
                  :id="'imaged-' + n"
                  v-model="gridType[n - 1][1]"
                  @change="
                    saveData(
                      $event,
                      boxRecordId,
                      'boxes',
                      'gridProperty',
                      true,
                      {
                        gridProperty: {
                          [this.gridNameFromNumber(n)]: {
                            gridType: this.gridType[n - 1],
                          },
                          gridupdate: [gridNameFromNumber(n), 'gridType'],
                          puckId: puckId,
                          wellNo: wellNo,
                          rackIndex: this.dataChainForMove.rack,
                          puckIndex: this.puckIndex,
                        },
                      }
                    )
                  "
                />
                <label
                  class="pl-1 cursor-pointer leading-none"
                  :name="'screentype-' + n"
                  :for="'imaged-' + n"
                  >Imaged</label
                >
              </div>
              <div class="flex items-end">
                <input
                  class="cursor-pointer w-4 h-4"
                  style="margin-bottom: 0"
                  type="checkbox"
                  :checked="!!gridType[n - 1][2]"
                  :name="'screentype-' + n"
                  :id="'tossed-' + n"
                  v-model="gridType[n - 1][2]"
                  @change="
                    saveData(
                      $event,
                      boxRecordId,
                      'boxes',
                      'gridProperty',
                      true,
                      {
                        gridProperty: {
                          [this.gridNameFromNumber(n)]: {
                            gridType: this.gridType[n - 1],
                          },
                          gridupdate: [gridNameFromNumber(n), 'gridType'],
                          puckId: puckId,
                          wellNo: wellNo,
                          rackIndex: this.dataChainForMove.rack,
                          puckIndex: this.puckIndex,
                        },
                      }
                    )
                  "
                />
                <label
                  class="pl-1 cursor-pointer leading-none"
                  :name="'screentype-' + n"
                  :for="'tossed-' + n"
                  >Tossed</label
                >
              </div>
            </div>
          </div>
          <div class="flex justify-between items-end flex-wrap">
            <div class="grid grid-cols-2 gap-x-3 gap-y-0 text-xs flex-shrink-0">
              <div class="inv-form-label">Date Created:</div>
              <span
                class="inv-form-label inline-block text-xs !font-semibold !text-slate-600"
                >Last modified:</span
              >

              <DatePicker
                class="flex"
                timezone="utc"
                v-model="showDatePicker[n - 1]"
              >
                <template v-slot="{ inputValue, inputEvents }">
                  <div class="inline-block">
                    <input
                      class="inv-form-input bg-white"
                      style="margin: 0"
                      :value="inputValue"
                      v-on="!isReadOnly ? inputEvents : null"
                    />
                  </div>
                </template>
              </DatePicker>
              <div>
                {{
                  getGridAtPosition(n)?.dateModified
                    ? cleanDate(getGridAtPosition(n).dateModified, true)
                    : wellData &&
                      wellData[gridNameFromNumber(n)] &&
                      wellData[gridNameFromNumber(n)].dateModified
                    ? cleanDate(
                        wellData[gridNameFromNumber(n)].dateModified,
                        true
                      )
                    : "N/A"
                }}
              </div>
            </div>

            <div
              v-if="!isReadOnly && gridName[n - 1] && !clearInProgress[n]"
              class="flex items-end flex-1 justify-end"
            >
              <div class="mr-4 flex-col flex items-center">
                <div class="fadeoutbutton">Copied</div>
                <button
                  class="btn-blue bg-green-800"
                  @click="copyGrid($event, n)"
                >
                  Copy Grid
                </button>
              </div>

              <div>
                <div class="flex justify-center relative">
                  <div
                    class="flex relative justify-center items-center border rounded bg-red-200 border-red-800 px-1"
                  >
                    <input
                      class="flex-0 mr-1"
                      type="checkbox"
                      :ref="'archive' + n"
                      :id="'archive' + n"
                      style="margin-bottom: 0; width: 1rem; height: 1rem"
                    /><label
                      class="cursor-pointer block top-px relative overflow-hidden"
                      :for="'archive' + n"
                      >Archive</label
                    >
                  </div>
                </div>
                <button class="btn-blue bg-red-800" @click="removeGrid(n)">
                  Empty Grid
                </button>
              </div>
            </div>

            <div
              v-else-if="!isReadOnly && !clearInProgress[n]"
              class="flex flex-1 justify-end"
            >
              <div
                :class="[getCopiedGrid.name ? 'visible' : 'invisible']"
                class="flex items-end"
              >
                <button class="btn-blue bg-orange-700" @click="pasteGrid(n)">
                  Paste Grid
                </button>
              </div>
              <div class="ml-4">
                <div>
                  <!---just for space--->
                  <div class="flex justify-center invisible">
                    <input
                      class="flex-0 mr-1"
                      type="checkbox"
                      checked="true"
                      style="margin-bottom: 0; width: 1rem; height: 1rem"
                    /><label class="cursor-pointer">Archive</label>
                  </div>
                  <button class="btn-blue bg-sky-900" @click="importGrid(n)">
                    Import Grid
                  </button>
                </div>
              </div>
            </div>
            <div
              v-show="clearInProgress[n]"
              :ref="'fadearchive' + n"
              class="fadeoutbutton"
            ></div>
          </div>
        </div>
      </div>
      <div
        style="background-color: rgb(217, 217, 217)"
        class="rounded-md mt-2 p-4 hidden"
        v-if="!isReadOnly"
      >
        <move-box-or-grid
          :data-chain-for-move="dataChainForMove"
          :puck-data="puckData"
          :is-grid="{
            name: gridName[n - 1],
            description: gridDescription[n - 1],
            gridType: gridType[n - 1],
          }"
          :has-grid-name="gridNameFromNumber(n)"
          :active-well-no="wellNo"
        />
      </div>
      <lamella-section
        v-if="getGridAtPosition(n)?.id && forTomography[n - 1]"
        :ref="'lamellaSection-' + n"
        :grid-id="getGridAtPosition(n).id"
        :grid-name="getGridAtPosition(n).name"
        :readonly="isReadOnly"
        :auto-expand="true"
      />
    </div>
  </div>
  <div
    v-if="!isReadOnly"
    class="w-full flex flex-col items-center justify-center"
  >
    <!-- <button
      id="saveUserChanges"
      ref="saveUserChanges"
      class="btn-blue relative py-2 px-4"
      @click="appStore.state.buttonFXinit($event), saveAllGrids($event)"
    >
      <button-inner>Save All Grids</button-inner>
    </button> -->
    <div class="fadeoutbutton text-xs">Added</div>
  </div>
</template>
<script>
import { DatePicker } from "v-calendar";
import GridImport from "../../../modal-inners/import-inner.vue";
import MoveBoxOrGrid from "./MoveBoxOrGrid.vue";
import LamellaSection from "./LamellaSection.vue";
import inventoryUiActions from "../../../../mixins/inventoryUiActions";
import { useInventoryStore } from "../../../../stores/inventory";
import { GRID_CATALOG_TYPE_OPTIONS, GRID_CATALOG_TYPE_GROUPS } from "../../../../constants/gridCatalogTypes";
export default {
  mixins: [inventoryUiActions],
  components: { GridImport, MoveBoxOrGrid, LamellaSection, DatePicker },
  props: [
    "boxImage",
    "boxSetting",
    "wellData",
    "cleanDate",
    "wellNo",
    "boxType",
    "puckId",
    "puckData",
    "puckIndex",
    "dataChainForMove",
    "checkReadOnly",
  ],
  inject: ["getCopiedGrid", "setCopiedGrid", "saveData"],

  computed: {
    gridChangedUpdatePuckVisual() {
      return this.appStore.state.gridChangedPuckVisualTrigger;
    },
    boxRecordId() {
      return this.wellData?.id || this.wellData?.id || null;
    },
    datePickerClone() {
      return JSON.stringify(this.showDatePicker);
    },

    gridTypeComp() {
      console.log("fired comp!");
      let tempArrayGrid1 = this.getGridAtPosition(1)?.gridType;

      let tempArrayGrid2 = this.getGridAtPosition(2)?.gridType;
      let tempArrayGrid3 = this.getGridAtPosition(3)?.gridType;
      let tempArrayGrid4 = this.getGridAtPosition(4)?.gridType;

      console.log(
        tempArrayGrid1,
        tempArrayGrid2,
        tempArrayGrid3,
        tempArrayGrid4
      );

      //legacy code check
      if (this.getGridAtPosition(1)?.gridType == "Screened")
        tempArrayGrid1 = [1, 0, 0];
      if (
        this.getGridAtPosition(1)?.gridType == "Not Screened" ||
        !this.getGridAtPosition(1)?.gridType
      )
        tempArrayGrid1 = [0, 0, 0];
      if (this.getGridAtPosition(2)?.gridType == "Screened")
        tempArrayGrid2 = [1, 0, 0];
      if (
        this.getGridAtPosition(2)?.gridType == "Not Screened" ||
        !this.getGridAtPosition(2)?.gridType
      )
        tempArrayGrid2 = [0, 0, 0];
      if (this.getGridAtPosition(3)?.gridType == "Screened")
        tempArrayGrid3 = [1, 0, 0];
      if (
        this.getGridAtPosition(3)?.gridType == "Not Screened" ||
        !this.getGridAtPosition(3)?.gridType
      )
        tempArrayGrid3 = [0, 0, 0];
      if (
        this.getGridAtPosition(4)?.gridType == "Not Screened" ||
        !this.getGridAtPosition(4)?.gridType
      )
        tempArrayGrid4 = [0, 0, 0];
      if (this.getGridAtPosition(4)?.gridType == "Screened")
        tempArrayGrid4 = [1, 0, 0];

      return JSON.parse(
        JSON.stringify([
          tempArrayGrid1,
          tempArrayGrid2,
          tempArrayGrid3,
          tempArrayGrid4,
        ])
      );
    },
    boxOrderArray() {
      if (this.boxSetting == 2) return [1, 2, 4, 3];
      else if (this.boxSetting == 3) return [4, 1, 3, 2];
      else if (this.boxSetting == 4) return [4, 3, 1, 2];
      else if (this.boxSetting == 5) return [1, 4, 2, 3];
      else if (this.boxSetting == 6) return [1, 3, 2, 4];
      else return [1, 2, 3, 4];
    },
    isReadOnly() {
      return this.wellData?.readOnly;
    },
    gridCatalogTypeGroups() {
      return GRID_CATALOG_TYPE_GROUPS.map((g) => ({
        label: g.label,
        options: GRID_CATALOG_TYPE_OPTIONS.slice(g.start, g.end + 1),
      }));
    },
  },

  data() {
    return {
      isUploading: {},
      activeImportGridNumber: null,
      clearInProgress: [],
      showDatePicker: [
        this.getGridAtPosition(1)?.trueDateCreated ?? "",
        this.getGridAtPosition(2)?.trueDateCreated ?? "",
        this.getGridAtPosition(3)?.trueDateCreated ?? "",
        this.getGridAtPosition(4)?.trueDateCreated ?? "",
      ],
      showImport: false,
      //gridtype moved to compute du eto addressing screen logic

      gridType: [
        [0, 0, 0],
        [0, 0, 0],
        [0, 0, 0],
        [0, 0, 0],
      ],
      gridImage: [
        this.getGridAtPosition(1)?.imageurl ?? "",
        this.getGridAtPosition(2)?.imageurl ?? "",
        this.getGridAtPosition(3)?.imageurl ?? "",
        this.getGridAtPosition(4)?.imageurl ?? "",
      ],
      gridName: [
        this.getGridAtPosition(1)?.name ?? "",
        this.getGridAtPosition(2)?.name ?? "",
        this.getGridAtPosition(3)?.name ?? "",
        this.getGridAtPosition(4)?.name ?? "",
      ],
      gridDescription: [
        this.getGridAtPosition(1)?.description ?? "",
        this.getGridAtPosition(2)?.description ?? "",
        this.getGridAtPosition(3)?.description ?? "",
        this.getGridAtPosition(4)?.description ?? "",
      ],
      gridCatalogType: [
        this.getGridAtPosition(1)?.gridCatalogType ?? "",
        this.getGridAtPosition(2)?.gridCatalogType ?? "",
        this.getGridAtPosition(3)?.gridCatalogType ?? "",
        this.getGridAtPosition(4)?.gridCatalogType ?? "",
      ],
      forTomography: [
        !!this.getGridAtPosition(1)?.forTomography,
        !!this.getGridAtPosition(2)?.forTomography,
        !!this.getGridAtPosition(3)?.forTomography,
        !!this.getGridAtPosition(4)?.forTomography,
      ],
    };
  },

  watch: {
    gridChangedUpdatePuckVisual(newValue) {
      //this is for the weird bug where after updating in store it uses the same memory address as the gridtype
      if (newValue) {
        setTimeout(() => {
          this.gridType = JSON.parse(JSON.stringify(this.gridTypeComp));
        }, 100);
      }
    },
    datePickerClone(newValue, oldValue) {
      //using a clone of computed because deep(object type) doesnt track newvalue oldvalue changes
      console.log(newValue, oldValue);
      // Note: `newValue` will be equal to `oldValue` here
      // on nested mutations as long as the object itself
      // hasn't been replaced.
      // const a = new Date(oldValue).toLocaleDateString();
      // const b = new Date(newValue).toLocaleDateString();
      if (!newValue) return;
      let indexThatChanged;
      newValue = JSON.parse(newValue);
      oldValue = JSON.parse(oldValue);
      for (let i = 0; i < newValue.length; i++) {
        if (newValue[i] != oldValue[i]) {
          console.log(i, newValue[i], oldValue[i]);
          indexThatChanged = i;
          break;
        }
      }
      const n = indexThatChanged + 1;

      let date1 = this.showDatePicker[n - 1]; // Your first date object
      let date2 = this.getGridAtPosition(n)?.trueDateCreated; // Another date object you're comparing against

      // Function to format a date as 'YYYY-MM-DD'
      function formatDate(date) {
        let d = new Date(date),
          month = "" + (d.getMonth() + 1),
          day = "" + d.getDate(),
          year = d.getFullYear();

        if (month.length < 2) month = "0" + month;
        if (day.length < 2) day = "0" + day;

        return [year, month, day].join("-");
      }

      let formattedDate1 = formatDate(date1);
      let formattedDate2 = formatDate(date2);
      console.log(formattedDate1, formattedDate2);

      if (formattedDate1 === formattedDate2) {
        return;
      }

      console.log(n);
      this.saveData(null, this.boxRecordId, "boxes", "gridProperty", true, {
        gridProperty: {
          //this key has to be first due to use of store's updateitem object keys 0 check
          [this.gridNameFromNumber(n)]: {
            trueDateCreated: this.showDatePicker[n - 1],
          },

          gridupdate: [this.gridNameFromNumber(n), "trueDateCreated"],
          puckId: this.puckId,
          wellNo: this.wellNo,
          rackIndex: this.dataChainForMove.rack,
          puckIndex: this.puckIndex,
        },
      });
    },
    wellData() {
      this.$nextTick(() => {
        this.reInitAll();
      });

      this.gridName = [
        this.getGridAtPosition(1)?.name ?? "",
        this.getGridAtPosition(2)?.name ?? "",
        this.getGridAtPosition(3)?.name ?? "",
        this.getGridAtPosition(4)?.name ?? "",
      ];

      this.showDatePicker = [
        this.getGridAtPosition(1)?.trueDateCreated ?? "",
        this.getGridAtPosition(2)?.trueDateCreated ?? "",
        this.getGridAtPosition(3)?.trueDateCreated ?? "",
        this.getGridAtPosition(4)?.trueDateCreated ?? "",
      ];

      this.gridDescription = [
        this.getGridAtPosition(1)?.description ?? "",
        this.getGridAtPosition(2)?.description ?? "",
        this.getGridAtPosition(3)?.description ?? "",
        this.getGridAtPosition(4)?.description ?? "",
      ];
      this.gridCatalogType = [
        this.getGridAtPosition(1)?.gridCatalogType ?? "",
        this.getGridAtPosition(2)?.gridCatalogType ?? "",
        this.getGridAtPosition(3)?.gridCatalogType ?? "",
        this.getGridAtPosition(4)?.gridCatalogType ?? "",
      ];
      this.forTomography = [
        !!this.getGridAtPosition(1)?.forTomography,
        !!this.getGridAtPosition(2)?.forTomography,
        !!this.getGridAtPosition(3)?.forTomography,
        !!this.getGridAtPosition(4)?.forTomography,
      ];

      console.log("well data changed", this.gridImage);
      this.gridImage = [
        this.getGridAtPosition(1)?.imageurl ?? "",
        this.getGridAtPosition(2)?.imageurl ?? "",
        this.getGridAtPosition(3)?.imageurl ?? "",
        this.getGridAtPosition(4)?.imageurl ?? "",
      ];

      console.log("well data changed", this.gridImage);
    },
  },
  methods: {
    // async getUploadUrl(input) {
    //   const url = `${process.env.VUE_APP_HOST}/api/v1/users/cloudimageurl`;

    //   const request = new Request(url, {
    //     credentials: "include",
    //     method: "GET",

    //     headers: { "content-type": "application/json" },
    //   });

    //   try {
    //     const response = await fetch(url, request);
    //     const data = await response.json();
    //     console.log(data);
    //     input.previousSibling.innerHTML = data.result.uploadURL;
    //     // this.uploadGridImage(input, 1)
    //   } catch (error) {
    //     console.error("Error fetching upload URL:", error);
    //   }
    // },
    // triggerFileInput(n) {
    //   const refName = "fileInput" + n;
    //   if (this.$refs[refName]) {
    //     this.$refs[refName].value = "";
    //     this.$refs[refName].click();
    //   } else {
    //     console.error(`File input ref '${refName}' not found.`);
    //   }
    // },

    // --- Method called when a file is selected via the input ---
    async handleFileChange(inputElement, n) {
      const file = inputElement.files ? inputElement.files[0] : null;
      if (!file) {
        console.log("No file selected or selection cancelled.");
        return;
      }

      // --- Set Loading State (Vue 3 handles reactivity directly) ---
      this.isUploading[n] = true; // Direct assignment works

      // --- UI Animation Setup ---
      const container = inputElement.closest("div");
      const animatedText = container?.querySelector(".text-black.hidden"); // Or add a specific ref/class
      const addButton = container?.querySelector(".addimagebutton"); // Might need more specific selector
      const editGroup = container?.querySelector(".editgroup");
      let dotCount = 0;
      let animationInterval = null;

      function animateDots() {
        // ... (animation logic as before) ...
        if (!animatedText) return;
        let text = "Uploading image";
        for (let i = 0; i < dotCount; i++) text += ".";
        animatedText.textContent = text;
        dotCount = (dotCount + 1) % 4;
      }
      function startAnimation() {
        // ... (start animation logic as before, hide buttons/links) ...
        stopAnimation(false); // Clear previous, don't show controls yet
        if (animatedText) animatedText.classList.remove("hidden");
        if (addButton) addButton.style.display = "none";
        if (editGroup) editGroup.style.display = "none";
        animateDots();
        animationInterval = setInterval(animateDots, 500);
      }
      const stopAnimation = (showOriginalControls = true) => {
        // ... (stop animation logic as before, show correct button/link) ...
        if (animationInterval) clearInterval(animationInterval);
        if (animatedText) animatedText.classList.add("hidden");
        if (showOriginalControls) {
          // Use 'this' since stopAnimation is defined within the method scope
          if (this.gridImage?.[n - 1]) {
            if (editGroup) editGroup.style.display = "flex";
            if (addButton) addButton.style.display = "none";
          } else {
            if (addButton) addButton.style.display = "inline-block";
            if (editGroup) editGroup.style.display = "none";
          }
        }
      };

      startAnimation();

      try {
        // --- 1. Get Upload URL from Backend ---
        const urlEndpoint = `${import.meta.env.VITE_APP_HOST}/api/v1/users/cloudimageurl`;
        const fileName = file.name;
        const urlRequestOptions = {
          credentials: "include",
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ fileName }),
        }; // Add Auth if needed
        console.log(`[Grid ${n}] Requesting upload URL...`);
        const urlResponse = await fetch(urlEndpoint, urlRequestOptions);
        if (!urlResponse.ok) {
          /* ... error handling ... */ throw new Error(
            `Failed to get upload URL...`
          );
        }
        const urlData = await urlResponse.json();
        if (!urlData.success || !urlData.result?.uploadURL) {
          /* ... error handling ... */ throw new Error(
            "Could not retrieve upload address."
          );
        }
        const uploadURL = urlData.result.uploadURL;
        console.log(`[Grid ${n}] Got upload URL.`);

        // --- 2. Prepare FormData ---
        const formData = new FormData();
        formData.append("file", file);

        // --- 3. Upload to Cloudflare ---
        console.log(`[Grid ${n}] Uploading to Cloudflare...`);
        const response = await fetch(uploadURL, {
          method: "POST",
          body: formData,
        });
        if (!response.ok) {
          /* ... error handling ... */ throw new Error(`Upload failed...`);
        }
        const data = await response.json();
        console.log(`[Grid ${n}] Cloudflare Success:`, data);
        if (!data.success || !data.result?.variants?.[0]) {
          /* ... error handling ... */ throw new Error(
            "Upload succeeded but response format..."
          );
        }
        const newImageUrl = data.result.variants[0];

        // --- 4. Save to your backend ---
        console.log(`[Grid ${n}] Saving to application backend...`);
        // const previousImageUrl = this.gridImage[n - 1] || null;
        // await this.saveData(/* ... parameters using newImageUrl and previousImageUrl ... */); // Ensure saveData is defined/imported

        // --- 5. Update local state (Vue 3 handles reactivity directly) ---

        await this.saveData(
          null,
          this.boxRecordId,
          "boxes",
          "gridProperty",
          true,
          {
            gridProperty: {
              [this.gridNameFromNumber(n)]: {
                imageurl: data.result.variants[0],
              },
              gridupdate: [this.gridNameFromNumber(n), "imageurl"],
              imageurltodelete: this.gridImage[n - 1],
              puckId: this.puckId,
              wellNo: this.wellNo,
              rackIndex: this.dataChainForMove.rack,
              puckIndex: this.puckIndex,
            },
          }
        );
        this.gridImage[n - 1] = newImageUrl; // Direct assignment works
        console.log(`[Grid ${n}] Local state updated.`);

        stopAnimation(); // Stop animation, show correct controls
      } catch (error) {
        console.error(`[Grid ${n}] Upload failed:`, error);
        alert(`Adding image failed. ${error.message || error}`);
        stopAnimation(); // Stop animation, show correct controls on error
      } finally {
        // --- Reset Loading State (Vue 3 handles reactivity directly) ---
        this.isUploading[n] = false; // Direct assignment works
        inputElement.value = ""; // Clear file input
        console.log(`[Grid ${n}] Upload process finished.`);
      }
    },

    async uploadGridImage(input, n) {
      const file = input.files[0];
      if (!file) return;
      const formData = new FormData();
      formData.append("file", file);
      let dotCount = 0;
      const animatedText = input.nextSibling;
      function animateDots() {
        let text = "Uploading image";
        for (let i = 0; i < dotCount; i++) {
          text += ".";
        }
        animatedText.textContent = text;

        if (dotCount < 3) {
          dotCount++;
        } else {
          dotCount = 0;
        }
      }

      // Replace with your actual upload URL received from Cloudflare
      const uploadURL = input.previousSibling.previousSibling.innerText;
      console.log(
        `[Grid ${n}] Attempting upload. URL retrieved from DOM: "${uploadURL}"`
      ); // Log URL with quotes

      console.log(uploadURL, input.previousSibling.previousSibling);

      if (uploadURL) {
        input.nextSibling.classList.remove("hidden");
        input.previousSibling.classList.add("hidden");
        setInterval(animateDots, 500);

        try {
          const response = await fetch(uploadURL, {
            method: "POST",
            body: formData,
          });

          if (!response.ok) {
            throw new Error(
              response.status == 415 ? "Unsupported Media Type" : "Error"
            );
          }

          const data = await response.json();

          console.log("Success:", data);

          if (!data.result.uploaded) throw data.errors;

          await this.saveData(
            null,
            this.boxRecordId,
            "boxes",
            "gridProperty",
            true,
            {
              gridProperty: {
                [this.gridNameFromNumber(n)]: {
                  imageurl: data.result.variants[0],
                },
                gridupdate: [this.gridNameFromNumber(n), "imageurl"],
                imageurltodelete: this.gridImage[n - 1],
                puckId: this.puckId,
                wellNo: this.wellNo,
                rackIndex: this.dataChainForMove.rack,
                puckIndex: this.puckIndex,
              },
            }
          );

          // This will now execute after saveData resolves
          console.log("then unhide");
          this.gridImage[n - 1] = data.result.variants[0];
          input.nextSibling.classList.add("hidden");
          input.previousSibling.classList.remove("hidden");
        } catch (error) {
          // Handle errors
          alert("Adding image failed. " + error);
          input.nextSibling.classList.add("hidden");
          input.previousSibling.classList.remove("hidden");
        }
      }
    },
    pasteGrid(n) {
      this.gridName[n - 1] = this.getCopiedGrid.name;
      this.gridType[n - 1] = this.getCopiedGrid.type;
      this.gridCatalogType[n - 1] = this.getCopiedGrid.catalogType || "";
      this.forTomography[n - 1] = !!this.getCopiedGrid.forTomography;
      this.gridImage[n - 1] = this.getCopiedGrid.imageurl;
      this.showDatePicker[n - 1] = this.getCopiedGrid.trueDateCreated;
      this.gridDescription[n - 1] = this.getCopiedGrid.description;
      this.saveData(null, this.boxRecordId, "boxes", "gridProperty", true, {
        gridProperty: {
          [this.gridNameFromNumber(n)]: {
            gridType: this.gridType[n - 1],
            gridCatalogType: this.gridCatalogType[n - 1] || null,
            forTomography: this.forTomography[n - 1],
            name: this.gridName[n - 1],
            trueDateCreated: this.showDatePicker[n - 1],
            imageurl: this.gridImage[n - 1],
            description: this.gridDescription[n - 1],
          },

          puckId: this.puckId,
          wellNo: this.wellNo,
          rackIndex: this.dataChainForMove.rack,
          puckIndex: this.puckIndex,
          gridupdate: [this.gridNameFromNumber(n), "saveall"],
        },
      });
      // this.notifyNotSaved();
    },
    copyGrid(ev, n) {
      this.setCopiedGrid({
        name: this.gridName[n - 1],
        type: this.gridType[n - 1],
        catalogType: this.gridCatalogType[n - 1] || "",
        forTomography: this.forTomography[n - 1],
        imageurl: null,
        trueDateCreated: this.showDatePicker[n - 1],
        description: this.gridDescription[n - 1],
      });
      ev.target.previousSibling.addEventListener("transitionend", () => {
        ev.target.previousSibling.classList.remove("fadeinbutton");
        ev.target.previousSibling.classList.add("fadeoutbutton");
      });

      ev.target.previousSibling.classList.remove("fadeoutbutton");
      ev.target.previousSibling.classList.add("fadeinbutton");
    },
    async removeGrid(n) {
      const deleted = confirm("Are you sure you want to delete this grid?");
      if (!deleted) return;
      let saverefofimage = JSON.stringify(this.gridImage[n - 1]);
      console.log("checktest", this.$refs["archive" + n][0].checked);
      if (this.$refs["archive" + n][0].checked) {
        console.log("wtf i checked you!");
        this.clearInProgress[n] = true;
        await this.createGridArchive(
          this.gridName[n - 1],
          this.gridType[n - 1],
          this.gridCatalogType[n - 1],
          this.gridImage[n - 1],
          this.gridDescription[n - 1],
          this.showDatePicker[n - 1]
        )
          .then((data) => {
            this.$refs["fadearchive" + n][0].textContent = data;
            this.$refs["fadearchive" + n][0].addEventListener(
              "transitionend",
              () => {
                this.$refs["fadearchive" + n][0].classList.remove(
                  "fadeinbutton"
                );
                this.$refs["fadearchive" + n][0].classList.add("fadeoutbutton");
                this.gridName[n - 1] = null;
                this.gridType[n - 1] = [0, 0, 0];
                this.gridCatalogType[n - 1] = "";
                this.forTomography[n - 1] = false;
                this.showDatePicker[n - 1] = null;
                this.gridImage[n - 1] = null;
                this.gridDescription[n - 1] = null;
                this.clearInProgress[n] = false;
              }
            );

            this.$refs["fadearchive" + n][0].classList.remove("fadeoutbutton");
            this.$refs["fadearchive" + n][0].classList.add("fadeinbutton");
          })
          .catch((err) => {
            this.$refs["fadearchive" + n][0].textContent = err;
            this.$refs["fadearchive" + n][0].addEventListener(
              "transitionend",
              () => {
                this.$refs["fadearchive" + n][0].classList.remove(
                  "fadeinbutton"
                );
                this.$refs["fadearchive" + n][0].classList.add("fadeoutbutton");
                this.gridName[n - 1] = null;
                this.gridType[n - 1] = [false, false, false];
                this.gridCatalogType[n - 1] = "";
                this.forTomography[n - 1] = false;
                this.gridImage[n - 1] = null;
                this.gridDescription[n - 1] = null;
                this.clearInProgress[n] = false;
              }
            );

            this.$refs["fadearchive" + n][0].classList.remove("fadeoutbutton");
            this.$refs["fadearchive" + n][0].classList.add("fadeinbutton");
          });
      } else {
        this.gridName[n - 1] = null;
        this.gridType[n - 1] = [false, false, false];
        this.gridCatalogType[n - 1] = "";
        this.forTomography[n - 1] = false;
        this.gridImage[n - 1] = null;
        this.showDatePicker[n - 1] = null;
        this.gridDescription[n - 1] = null;
      }

      this.saveData(null, this.boxRecordId, "boxes", "gridProperty", true, {
        gridProperty: {
          [this.gridNameFromNumber(n)]: {
            gridType: [false, false, false],
            gridCatalogType: null,
            forTomography: false,
            name: null,
            trueDateCreated: null,
            imageurl: null,
            description: null,
          },
          puckId: this.puckId,
          wellNo: this.wellNo,
          rackIndex: this.dataChainForMove.rack,
          puckIndex: this.puckIndex,
          keepArchive: this.$refs["archive" + n]?.[0]?.checked,
          imageurltodelete: JSON.parse(saverefofimage),
          gridupdate: [this.gridNameFromNumber(n), "removeall"],
        },
      });
    },
    importGrid(number) {
      this.showImport = true;
      this.activeImportGridNumber = number;
    },
    createGridArchive(name, type, gridCatalogType, image, description, datecreated) {
      console.log("increatearchive");
      return new Promise((res, rej) => {
        const body = {
          name,
          imageurl: image,
          gridType: type,
          gridCatalogType: gridCatalogType || null,
          description,
          trueDateCreated: datecreated,
        };
        this.appStore
          .dispatch("createItem", {
            item: "gridarchives",
            body,
          })
          .then((data) => {
            console.log(data);
            res("Archive created.");
          })
          .catch((err) => {
            console.log(err);
            rej("Failed to create archive!");
          });
      });
    },
    checkBorderColor(ev, isRadioButton) {
      let bordercontainer = ev.target;
      let valueToCheck = ev.target.value;
      console.log(isRadioButton);
      if (isRadioButton) {
        bordercontainer = ev.target.parentElement.parentElement;
        valueToCheck = false;
        console.log('input[name="' + ev.target.name + '"]');
        bordercontainer
          .querySelectorAll('input[name="' + ev.target.name + '"]')
          .forEach((input) => {
            console.log(input);
            if (input.checked == true) valueToCheck = true;
          });
        console.log(valueToCheck);
        if (valueToCheck) {
          if (bordercontainer.classList.contains("outline"))
            bordercontainer.classList.remove("outline");
        } else {
          if (!bordercontainer.classList.contains("outline"))
            bordercontainer.classList.add("outline");
        }
      } else {
        if (valueToCheck) {
          if (bordercontainer.classList.contains("redborder"))
            bordercontainer.classList.remove("redborder");
        } else {
          if (!bordercontainer.classList.contains("redborder"))
            bordercontainer.classList.add("redborder");
        }
      }
    },
    async saveAllGrids(buttonev) {
      //dont think this is used at all anymore
      let body = { puckId: this.puckId, wellNo: this.wellNo };
      for (let i = 0; i < 4; i++) {
        if (
          this.gridName[i] ||
          this.gridType[i][0] ||
          this.gridType[i][1] ||
          this.gridType[i][2] ||
          this.gridImage[i] ||
          this.gridDescription[i] ||
          this.showDatePicker[i] ||
          this.gridCatalogType[i]
        ) {
          console.log(this.showDatePicker[i]);
          if (!this.gridName[i] && !this.showDatePicker[i]) {
            this.$refs["gridName" + (i + 1)].classList.add("redborder");
            return this.appStore.state.buttonFX(
              buttonev.target.closest("button")
            );
          } // else if (!this.gridType[i]) {
          //   this.$refs["gridType" + (i + 1)].classList.add("outline");
          //   return this.appStore.state.buttonFX(
          //     buttonev.target.closest("button")
          //   );
          // }
          console.log("yoooo");
          body[this.gridNameFromNumber(i + 1)] = {
            gridType: this.gridType[i],
            gridCatalogType: this.gridCatalogType[i] || null,
            name: this.gridName[i],
            imageurl: this.gridImage[i],
            description: this.gridDescription[i],
            trueDateCreated: this.showDatePicker[i],
          };
        } else {
          body[this.gridNameFromNumber(i + 1)] = {
            gridType: [0, 0, 0],
            gridCatalogType: null,
            name: null,
            description: null,
          };
        }
      }

      if (this.appStore.state.unsavedChangesMPBox) {
        this.appStore.state.promptUnsaveModal = true;

        let answer;
        try {
          answer = await this.appStore.state.promptAnswerPromise();
        } catch {
          //rejected

          answer = null;
        }

        this.appStore.state.promptUnsaveModal = false;
        if (!answer) {
          this.appStore.state.buttonFX(
            buttonev.target.closest("button"),
            "Cancelled"
          );
          return;
        } else {
          this.appStore.state.unsavedChangesMPGrid = false;
          this.appStore.state.unsavedChangesMPBox = false;
          if (document.getElementById("saveUserChanges")) {
            document.getElementById("saveUserChanges").style.outline = "none";
          }
        }
      }

      this.inventoryUpdateItem({
          item: "boxes",
          objid: this.boxRecordId,
          body,
          skipDewarReload: true,
        })
        .then(() => {
          this.notifySaved();
          this.appStore.state.buttonFX(
            buttonev.target.closest("button"),
            "Grids Saved"
          );
        })
        .catch(() => {
          this.appStore.state.buttonFX(
            buttonev.target.closest("button"),
            "ERROR: Saving Failed!"
          );
        });
    },
    notifySaved() {
      this.$refs.saveUserChanges.style.outline = "none";
      this.appStore.state.unsavedChangesMPGrid = false;
    },
    notifyNotSaved() {
      this.$refs.saveUserChanges.style.outline = "2px red dashed";
      this.appStore.state.unsavedChangesMPGrid = true;
    },
    saveGrid(number) {
      if (!this.gridName[number - 1]) {
        this.$refs["gridName" + number].classList.add("redborder");
        return;
      } else if (!this.gridType[number - 1]) {
        this.$refs["gridType" + number].classList.add("outline");
        return;
      }
      console.log("grid typ eis", this.gridType[number - 1]);
      this.inventoryUpdateItem({
        item: "boxes",
        objid: this.boxRecordId,
        body: {
          [this.gridNameFromNumber(number)]: {
            gridType: this.gridType[number - 1],
            gridCatalogType: this.gridCatalogType[number - 1] || null,
            name: this.gridName[number - 1],
            description: this.gridDescription[number - 1],
          },
          puckId: this.puckId,
          wellNo: this.wellNo,
        },
        skipDewarReload: true,
      });
    },
    gridNameFromNumber(number) {
      let name;
      switch (number) {
        case 1:
          name = "gridTopLeft";
          break;
        case 2:
          name = "gridTopRight";
          break;
        case 3:
          name = "gridBottomLeft";
          break;
        case 4:
          name = "gridBottomRight";
          break;
      }
      return name;
    },
    toggleTomography(n, ev) {
      const next = [...this.forTomography];
      next[n - 1] = ev.target.checked;
      this.forTomography = next;
      if (ev.target.checked) {
        const scrollToLamella = (attempts = 0) => {
          const ref = this.$refs["lamellaSection-" + n];
          const el = ref?.[0]?.$el || ref?.$el;
          if (el) {
            el.scrollIntoView({ behavior: "smooth", block: "end" });
          } else if (attempts < 10) {
            setTimeout(() => scrollToLamella(attempts + 1), 100);
          }
        };
        this.$nextTick(() => scrollToLamella());
      }
      this.saveData(ev, this.boxRecordId, 'boxes', 'gridProperty', true, {
        gridProperty: {
          [this.gridNameFromNumber(n)]: {
            forTomography: this.forTomography[n - 1],
          },
          gridupdate: [this.gridNameFromNumber(n), 'forTomography'],
          puckId: this.puckId,
          wellNo: this.wellNo,
          rackIndex: this.dataChainForMove.rack,
          puckIndex: this.puckIndex,
        },
      });
    },
    isKnownCatalogType(value) {
      return GRID_CATALOG_TYPE_OPTIONS.includes(value);
    },
    getGridCatalogTypeOptions(position) {
      const currentValue =
        this.gridCatalogType[position - 1] ||
        this.getGridAtPosition(position)?.gridCatalogType;
      if (currentValue && !GRID_CATALOG_TYPE_OPTIONS.includes(currentValue)) {
        return [currentValue, ...GRID_CATALOG_TYPE_OPTIONS];
      }
      return GRID_CATALOG_TYPE_OPTIONS;
    },
    getGridAtPosition(position) {
      const inventoryStore = useInventoryStore();
      const boxId = this.wellData?.id || this.wellData?.id;
      if (boxId) {
        const storeGrid = inventoryStore
          .getGridsForBox(boxId)
          .find((grid) => Number(grid.position) === Number(position));
        if (storeGrid) {
          return storeGrid;
        }
      }
      const gridName = this.gridNameFromNumber(position);
      return gridName ? this.wellData?.[gridName] || null : null;
    },
    getLamellaSummaryAtPosition(position) {
      const grid = this.getGridAtPosition(position);
      if (!grid?.id) {
        return { total: 0, active: 0, completed: 0, alert: 0, pending: 0, imageCount: 0, latestStage: null, latestStatus: null, latestTimestamp: null };
      }
      const inventoryStore = useInventoryStore();
      return inventoryStore.getLamellaSummaryForGrid(grid.id);
    },
    cloneSvg() {
      console.log(this.boxImage.children);
      for (let i = 0; i < 4; i++) {
        if (this.boxImage.children.length) {
          const clone = this.boxImage.cloneNode(true);
          const container = this.$refs["bigCircle-" + (i + 1)];
          const pieces = clone.querySelectorAll(".gridpieces ellipse");
          // if (this.boxType == "opencup") {
          //   pieces.forEach((piece) => {
          //     piece.remove();
          //   });
          // } else {
          //   pieces.forEach((piece, index) => {
          //     if (index != i) piece.remove();
          //     piece.style.display = "block";
          //   });
          // }
          pieces.forEach((piece, index) => {
            if (index != i) piece.remove();
            piece.style.display = "block";
          });
          container[0].innerHTML = "";
          console.log(container, "clone is", clone);
          // clone.children[0].removeAttribute("viewBox");
          // clone.children[0].style.aspectRatio = "1";
          clone.classList.add("aspect-square", "h-full");
          // clone.classList.add("h-full", "aspect-square", "w-4", "bg-black");
          clone.children[0].removeAttribute("width");
          clone.children[0].removeAttribute("height");
          clone.children[0].style.width = "100%";
          clone.children[0].style.height = "100%";
          // clone.children[0].classList.add("aspect-square");
          //         const atemplate = document.createElement("template");
          //         atemplate.innerHTML = `<div class="h-full bg-black aspect-square"><img class="h-full w-full" src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"></div>
          //  `;
          // clone.appendChild(atemplate.content.firstChild);
          // clone.children[0].style.flexGrow = 1;
          // const imagetemplate = document.createElement("template");
          // imagetemplate.innerHTML = `<img class="h-full" src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7">`;
          // clone.children[1].appendChild(clone.children[0]);
          // clone.children[0].appendChild(imagetemplate.content.firstChild);
          container[0].appendChild(clone);

          // container[0].appendChild(atemplate.content.firstChild);
          // container[0].style.height = "100%";
        }
      }
    },
    reInitAll() {
      this.cloneSvg();
      this.checkReadOnly(true);
      //round circle number

      this.gridType = this.gridTypeComp;

      document.querySelectorAll(".circleresize").forEach((elem) => {
        elem.style.width = elem.offsetHeight + "px";
      });
    },
    feedIntoGrid(dataObj) {
      this.showImport = false;
      const { gridDescription, gridName, gridType, gridImage, gridCatalogType, forTomography: importForTomography } = dataObj;
      const n = this.activeImportGridNumber;
      if (!n) return;
      this.gridName[n - 1] = gridName;
      this.gridDescription[n - 1] = gridDescription;

      this.gridType[n - 1] = gridType;
      this.gridCatalogType[n - 1] = gridCatalogType || "";
      this.forTomography[n - 1] = !!importForTomography;
      this.gridImage[n - 1] = gridImage;
      // this.notifyNotSaved();

      this.saveData(null, this.boxRecordId, "boxes", "gridProperty", true, {
        gridProperty: {
          [this.gridNameFromNumber(n)]: {
            gridType: this.gridType[n - 1],
            gridCatalogType: this.gridCatalogType[n - 1] || null,
            forTomography: this.forTomography[n - 1],
            name: this.gridName[n - 1],
            imageurl: this.gridImage[n - 1],
            trueDateCreated: this.showDatePicker[n - 1],
            description: this.gridDescription[n - 1],
          },
          puckId: this.puckId,
          wellNo: this.wellNo,
          rackIndex: this.dataChainForMove.rack,
          puckIndex: this.puckIndex,
        },
      });
      this.activeImportGridNumber = null;
    },
  },

  mounted() {
    console.log("well data" + JSON.stringify(this.wellData));
    this.reInitAll();
  },
};
</script>

<style scoped>
input,
textarea {
  border: 2px solid rgb(118, 155, 186);
  border-radius: 6px;
  padding: 0.3rem;
  margin-bottom: 0.5rem;
  font-size: 0.9rem;
}

.blueborder {
  border: 2px solid rgb(118, 155, 186);
  border-radius: 6px;
  padding: 0.3rem;
  margin-bottom: 0.5rem;
  font-size: 0.9rem;
}

.redborder {
  border-color: rgb(200, 0, 0);
}

input[type="radio"] {
  margin-bottom: 0;
}

input:focus,
textarea:focus {
  border-color: rgb(43, 94, 141);
}

.blueborder:focus {
  border-color: rgb(43, 94, 141);
}

.outline {
  outline: rgb(200, 0, 0) solid 2px;
}

/* ── Tomography toggle ── */
.tomography-toggle {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
  padding: 0.45rem 0.7rem;
  border-radius: 0.6rem;
  border: 1.5px solid rgba(148, 163, 184, 0.35);
  background: rgba(241, 245, 249, 0.7);
  transition: all 0.2s ease;
  user-select: none;
}
.tomography-toggle:hover {
  border-color: rgba(14, 165, 233, 0.4);
  background: rgba(224, 242, 254, 0.5);
}
.tomography-toggle--active {
  border-color: rgba(6, 182, 212, 0.5);
  background: linear-gradient(135deg, rgba(6, 182, 212, 0.08), rgba(14, 165, 233, 0.08));
}
.tomography-toggle__input {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
  pointer-events: none;
}
.tomography-toggle__track {
  position: relative;
  display: inline-block;
  width: 2rem;
  height: 1.15rem;
  border-radius: 999px;
  background: #cbd5e1;
  transition: background 0.2s ease;
  flex-shrink: 0;
}
.tomography-toggle--active .tomography-toggle__track {
  background: linear-gradient(135deg, #06b6d4, #0ea5e9);
}
.tomography-toggle__thumb {
  position: absolute;
  top: 2px;
  left: 2px;
  width: calc(1.15rem - 4px);
  height: calc(1.15rem - 4px);
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.18);
  transition: transform 0.2s ease;
}
.tomography-toggle--active .tomography-toggle__thumb {
  transform: translateX(calc(2rem - 1.15rem));
}
.tomography-toggle__label {
  font-size: 0.78rem;
  font-weight: 600;
  letter-spacing: 0.04em;
  color: #475569;
  border: none !important;
  margin: 0 !important;
  padding: 0 !important;
}
.tomography-toggle--active .tomography-toggle__label {
  color: #0e7490;
}
.tomography-toggle__badge {
  font-size: 0.62rem;
  font-weight: 800;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  padding: 0.18rem 0.45rem;
  border-radius: 999px;
  background: rgba(6, 182, 212, 0.12);
  color: #0e7490;
  border: 1px solid rgba(6, 182, 212, 0.25);
}
</style>
